export enum WidgetSystemServerSyncableTypes {
    Website = "App\\Models\\Website",
    Branch = "App\\Models\\Branch",
    Widget = "widget",
}
